module.exports = __webpack_public_path__ + "static/Layer-9c95a7052a4636fd81ec89529b398384.jpg";